export const SET_IS_LOADING = "SET_IS_LOADING";
export const SET_COMPANY_HISTORIES = "SET_COMPANY_HISTORIES";

